module.exports = __webpack_public_path__ + "img/sc-4p-2023.43bf6b55.jpg";